export default "__VITE_ASSET__BmUhR0VL__"